import { render } from "./justify-exception.vue?vue&type=template&id=70e13726"
import script from "./justify-exception.vue?vue&type=script&lang=js"
export * from "./justify-exception.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__